import styled from "@emotion/styled";

import { DesignToken, SpacingToken } from "@livechat/design-system-react-components";

import { StyledPopperContent } from "components/popper-container";

export const BoxContainer = styled(StyledPopperContent)`
  position: relative;
  min-width: 300px;
  padding: 10px 11px;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: var(${SpacingToken.Spacing2});
`;

export const Body = styled.div`
  font-size: 14px;
`;

export const Footer = styled.div`
  margin-top: var(${SpacingToken.Spacing2});
  box-sizing: border-box;
`;

export const Title = styled.h3`
  margin-left: 7px;
  color: var(${DesignToken.ContentBasicPrimary});
  font-size: 13px;
  line-height: 16px;
  font-weight: 600;
  letter-spacing: 0.3px;
  text-overflow: ellipsis;
  overflow: hidden;
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 5px;
  right: 5px;
  width: 24px;
  height: 24px;
  padding: 7px;
  box-shadow: none;
  border: none;
  background-color: transparent;
  outline: none;
`;

export const ActionButton = styled.button`
  display: block;
  width: 100%;
  padding: 10px 25px;
  color: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => props.theme.filters.submit.default.color
  };
  font-weight: 600;
  font-size: 14px;
  letter-spacing: 0.2px;
  text-align: center;
  opacity: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => props.theme.filters.submit.default.opacity
  };
  background-color: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => props.theme.filters.submit.default.backgroundColor
  };
  border-color: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => props.theme.filters.submit.default.border.color
  };
  border-width: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => props.theme.filters.submit.default.border.width
  };
  border-style: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => props.theme.filters.submit.default.border.style
  };
  border-radius: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => props.theme.filters.submit.default.border.radius
  };
  box-shadow: none;
  outline: none;

  &:hover {
    color: ${
      // FIXME: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
      (props: any) => props.theme.filters.submit.hover.color
    };
    opacity: ${
      // FIXME: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
      (props: any) => props.theme.filters.submit.hover.opacity
    };
    background-color: ${
      // FIXME: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
      (props: any) => props.theme.filters.submit.hover.backgroundColor
    };
    border-color: ${
      // FIXME: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
      (props: any) => props.theme.filters.submit.hover.border.color
    };
    border-width: ${
      // FIXME: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
      (props: any) => props.theme.filters.submit.hover.border.width
    };
    border-style: ${
      // FIXME: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
      (props: any) => props.theme.filters.submit.hover.border.style
    };
    border-radius: ${
      // FIXME: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
      (props: any) => props.theme.filters.submit.hover.border.radius
    };
  }

  &.disabled {
    pointer-events: none;
    cursor: default;
    color: ${
      // FIXME: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
      (props: any) => props.theme.filters.submit.disabled.color
    };
    opacity: ${
      // FIXME: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
      (props: any) => props.theme.filters.submit.disabled.opacity
    };
    background-color: ${
      // FIXME: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
      (props: any) => props.theme.filters.submit.disabled.backgroundColor
    };
    border-color: ${
      // FIXME: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
      (props: any) => props.theme.filters.submit.disabled.border.color
    };
    border-width: ${
      // FIXME: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
      (props: any) => props.theme.filters.submit.disabled.border.width
    };
    border-style: ${
      // FIXME: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
      (props: any) => props.theme.filters.submit.disabled.border.style
    };
    border-radius: ${
      // FIXME: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
      (props: any) => props.theme.filters.submit.disabled.border.radius
    };
  }
`;
